import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.scss']
})
export class SelectGroupComponent implements OnInit {

  @Input() selected: any
  @Input() items: any[] = []
  @Input() isError: boolean = false

  @Output() selectedChange = new EventEmitter()

  constructor() { }

  ngOnInit(): void {

  }

  select(value: any): void {
    this.selected = value
    this.selectedChange.emit(value)
  }

}
